import React, { useState, useEffect, useCallback } from 'react';
import { Card, Button, Modal, Form, Spinner, Alert } from 'react-bootstrap';
import api from './api';

function AdminKlinikler() {
  const [klinikler, setKlinikler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [duzenlenenKlinik, setDuzenlenenKlinik] = useState(null);

  const klinikleriGetir = useCallback(async () => {
    try {
      const response = await api.get('/admin/klinikler');
      setKlinikler(response.data);
    } catch (err) {
      setError("Klinikler yüklenirken bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { klinikleriGetir(); }, [klinikleriGetir]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      ad: e.target.elements.ad.value,
      telefon: e.target.elements.telefon.value,
      adres: e.target.elements.adres.value,
      yonetici_kullanici_adi: e.target.elements.yonetici_kullanici_adi.value,
      yonetici_sifre: e.target.elements.yonetici_sifre.value,
      yonetici_eposta: e.target.elements.yonetici_eposta.value, // YENİ EKLENDİ
    };

    const isUpdating = !!duzenlenenKlinik?.id;
    const url = isUpdating ? `/admin/klinikler/${duzenlenenKlinik.id}` : '/admin/klinikler';
    const method = isUpdating ? 'put' : 'post';
    
    // Düzenleme sırasında şifre boşsa, veriden çıkar
    if (isUpdating && !formData.yonetici_sifre) {
        delete formData.yonetici_sifre;
    }

    try {
      await api[method](url, formData);
      setShowModal(false);
      klinikleriGetir();
    } catch (err) {
      alert(`Hata: ${err.response?.data?.mesaj || 'İşlem başarısız'}`);
    }
  };

  const handleSil = async (klinikId) => {
    if (!window.confirm('Bu kliniği silmek istediğinizden emin misiniz?')) return;
    try {
        await api.delete(`/admin/klinikler/${klinikId}`);
        klinikleriGetir();
    } catch(err) {
        alert(err.response?.data?.mesaj || 'Silme işlemi başarısız');
    }
  };

  const handleModalOpen = (klinik = null) => {
    setDuzenlenenKlinik(klinik);
    setShowModal(true);
  };

  if (loading) return <Spinner animation="border" variant="light" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Card className="glass-card text-white">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Card.Title as="h2">Klinik Yönetimi</Card.Title>
          <Button variant="light" onClick={() => handleModalOpen()}>+ Yeni Klinik Ekle</Button>
        </div>
        
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Klinik Adı</th>
                <th>Telefon</th>
                <th>Yönetici K. Adı</th>
                <th>Yönetici E-posta</th>
                <th className="text-end">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {klinikler.map(klinik => (
                <tr key={klinik.id}>
                  <td data-label="ID">{klinik.id}</td>
                  <td data-label="Klinik Adı">{klinik.ad}</td>
                  <td data-label="Telefon">{klinik.telefon || '-'}</td>
                  <td data-label="Yönetici K. Adı">{klinik.yonetici_kullanici_adi || 'Atanmamış'}</td>
                  <td data-label="Yönetici E-posta">{klinik.yonetici_eposta || '-'}</td>
                  <td data-label="İşlemler" className="text-end">
                    <Button variant="warning" size="sm" onClick={() => handleModalOpen(klinik)}>Düzenle</Button>
                    <Button variant="danger" size="sm" className="ms-2" onClick={() => handleSil(klinik.id)}>Sil</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </Card.Body>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{duzenlenenKlinik?.id ? 'Kliniği Düzenle' : 'Yeni Klinik Oluştur'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleFormSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Klinik Adı</Form.Label>
              <Form.Control name="ad" type="text" defaultValue={duzenlenenKlinik?.ad || ''} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Telefon</Form.Label>
              <Form.Control name="telefon" type="tel" defaultValue={duzenlenenKlinik?.telefon || ''} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Adres</Form.Label>
              <Form.Control as="textarea" name="adres" rows={2} defaultValue={duzenlenenKlinik?.adres || ''} />
            </Form.Group>
            <hr/>
            <h5 className="mb-3">Klinik Yöneticisi Bilgileri</h5>
            <Form.Group className="mb-3">
              <Form.Label>Yönetici Kullanıcı Adı</Form.Label>
              <Form.Control 
                name="yonetici_kullanici_adi" 
                type="text" 
                defaultValue={duzenlenenKlinik?.yonetici_kullanici_adi || ''}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Yönetici E-posta</Form.Label>
                <Form.Control name="yonetici_eposta" type="email" required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Yönetici Şifresi</Form.Label>
              <Form.Control 
                name="yonetici_sifre" 
                type="password" 
                required={!duzenlenenKlinik} 
                placeholder={duzenlenenKlinik ? 'Değiştirmek için doldurun' : ''} 
              />
            </Form.Group>
            <div className="d-flex justify-content-end">
              <Button variant="secondary" onClick={() => setShowModal(false)} className="me-2">İptal</Button>
              <Button variant="primary" type="submit">Kaydet</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Card>
  );
}
export default AdminKlinikler;
